<template>
	<div :class="embedded ? '' : ['p-5', 'rounded-lg', bgClass]">
		<h3
			class="mb-2 text-xl font-medium leading-none text-white"
			:class="$lowercaseHeadingClass"
		>
			{{ $t(summary.workplaceSignalKey) }}
		</h3>
		<p class="mb-0">
			{{ $t(summary.signalDescriptionKey) }}
		</p>
	</div>
</template>

<script>
export default {
	name: 'OverviewSummary',
	props: {
		summary: {
			type: Object,
			default: () => {}
		},
		bgClass: {
			type: String,
			default: 'bg-neutral-800'
		},
		embedded: {
			type: Boolean,
			default: false
		}
	}
}
</script>
